// extracted by mini-css-extract-plugin
module.exports = {"container":"TeamsTile_container__13yP6","logo":"TeamsTile_logo__hEUDF"};